import React from "react";
import { Container } from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import NormalValidation from "../../Forms/FormValidation/financing/NormalValidation";

const ProjectFinancingCreate = () => {
  document.title = "Novo Financiador - Khozi";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Financiador"
            breadcrumbItem="Novo Financiador"
          />
          <NormalValidation />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ProjectFinancingCreate;
